








































import { Component, Prop, Vue } from 'vue-property-decorator'
import YoutubeEmbed from '../components/YoutubeEmbed.vue'
import { Project } from '../types'

@Component({ components: { YoutubeEmbed } })
export default class extends Vue {
  @Prop()
  public projectKey!: string

  get project(): Project {
    const state = this.$store.state
    const projects = [...state.projects, ...state.speaking, ...state.mentorship]
    const proj = projects.filter(
      (p: Project) => this.projectKey !== undefined && p.details && p.details.projectKey === this.projectKey
    )[0]
    return proj
  }
}
